import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_MARKETDATA_API ||
  process.env.REACT_APP_API_URL?.replace(/\/[^/]+$/, '/marketdata');

const apiClientMarketdata = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClientMarketdata;